Promise = require 'bluebird'
React = require 'react'
$ = require 'jquery'
_ = require 'underscore'
Controller = require 'controller'
Auth = require 'db/auth'
ModelLoader = require 'db/model-loader'
track = require 'debug/track'
l = require 'lib/localize'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'
Util = require 'lib/util'
{ unsplashApi, toJson, constants } = require 'network/unsplash'
t = require('views/internal/recup-with-helpers')('create_board')
Alerts = require 'views/lib/alerts'
Dialog = require 'views/lib/dialog'
PopOver = require 'views/lib/pop-over'
LastOrganization = require 'lib/last-organization'

helpers = require './helpers'
BackgroundChooserComponent = require './background-chooser-component'
ColorChooserComponent = require './color-chooser-component'
PhotoChooserComponent = require './photo-chooser-component'
OrgChooserComponent = require './org-chooser-component'
VisChooserComponent = require './vis-chooser-component'

{ createBackgroundStyle, createColors, createPhotoFromResponse, preloadPermissions, preloadPhotos } = helpers
{ DEFAULT_COLLECTION_ID, PAGE_SIZE } = constants

COLORS = createColors()

module.exports = class CreateBoardComponent extends React.Component
  displayName: 'CreateBoardComponent'

  constructor: (props) ->
    @state =
      # XXX: These three values get out of sync when re-rendering
      # after state changes, which leads to duplicated state in
      # the child components in order to render them correctly.
      # If anyone has ideas on how to use the PopOver lifecycle
      # methods to keep the two in sync, that would be 💯.
      isBackgroundChooserVisible: false
      isColorChooserVisible: false
      isPhotoChooserVisible: false

      isLoadingVisPermissions: false
      isLoadingPhotos: false
      isOrgChooserVisible: false
      isSubmitting: false
      isVisChooserVisible: false
      background: COLORS[0]
      org: null
      orgsWithPermissions: []
      photos: []
      vis: 'private'
      title: props.defaultTitle ? ''
      defaultOrg: props.defaultOrg ? @getLastOrganization()

    super props

  componentDidMount: ->
    # Ensure that org visibility validation happens on mount
    @loadVisPermissions()
    # Load initial set of photos from Unsplash on mount
    @loadPhotos()
    # Persist width of submit button so we can use it when applying the loading class on submission
    @submitButtonWidth = @submitButtonElem?.getBoundingClientRect().width

    setTimeout (=>
      @titleInputElem?.focus()
      @titleInputElem?.select()), 10

  componentDidUpdate: (prevProps, prevState) ->
    if @state.isOrgChooserVisible
      @showOrgChooser()
    if @state.isVisChooserVisible
      @showVisChooser()
    if @state.isBackgroundChooserVisible
      @showBackgroundChooser()
    if @state.isColorChooserVisible && !prevState.isColorChooserVisible
      @showColorChooser()
    if @state.isPhotoChooserVisible && !prevState.isPhotoChooserVisible
      @showPhotoChooser()

  render: t.renderable ->
    {
      background
      isLoadingVisPermissions
      orgsWithPermissions
      org
    } = @state

    t.form '.create-board-form', { onSubmit: @onSubmit.bind @ }, =>
      # Flex container
      t.div =>
        t.div '.board-tile.create-board-tile', {
          className: t.classify { 'has-photo-background': background.isPhoto }
          ref: (elem) => @createBoardTileElem = elem
          style: createBackgroundStyle background
        }, =>
          t.button '.hide-dialog-trigger.unstyled-button', {
            onClick: @onHideDialogTriggerClick.bind @
            type: 'button'
          }, =>
            t.icon 'close'

          t.div =>
            @renderTitleInput()

          if isLoadingVisPermissions
            t.p '.checking-vis-permissions', =>
              t.text l ['checking visibility permissions']
          else
            if orgsWithPermissions.length
              t.div =>
                @renderOrgChooserTrigger()

            if org?.allowedVis.length != 0
              t.div =>
                @renderVisChooserTrigger()

        @renderBackgroundGrid()
      @renderSubmitButton()
      @renderErrorMessage()

  renderTitleInput: =>
    t.input '.subtle-input',
      disabled: @state.isSubmitting
      placeholder: t.l 'add board title'
      onBlur: @onTitleBlur.bind @
      onChange: @onTitleChange.bind @
      ref: (elem) => @titleInputElem = elem
      value: @state.title

  renderOrgChooserTrigger: =>
    t.button '.subtle-chooser-trigger.unstyled-button.org-chooser-trigger', {
      type: 'button'
      onClick: @onOrgChooserTriggerClick.bind @
      ref: (elem) => @orgTriggerElem = elem
    }, =>
      t.span =>
        if @state.org?
          t.text @state.org.model.get 'displayName'
        else
          t.format 'no team'

  renderVisChooserTrigger: =>
    t.button '.subtle-chooser-trigger.unstyled-button.vis-chooser-trigger', {
      type: 'button'
      onClick: @onVisChooserTriggerClick.bind @
      ref: (elem) => @visTriggerElem = elem
    }, =>
      switch @state.vis
        when 'private'
          t.icon 'private'
          t.text l ['board perms', 'private', 'name']
        when 'org'
          t.icon 'organization-visible'
          t.text l ['board perms', 'org', 'name']
        when 'public'
          t.icon 'public'
          t.text l ['board perms', 'public', 'name']

  renderBackgroundGrid: =>
    if @state.photos.length == 0
      backgrounds = COLORS.slice 0, 8
    else
      backgrounds = @state.photos.slice(0, 4).concat COLORS.slice(0, 4)

    if !(_.find backgrounds, (bg) => bg.value == @state.background.value)
      backgrounds = [@state.background].concat backgrounds.slice(1)

    t.ul '.background-grid', { ref: (elem) => @backgroundGridElem = elem }, =>
      backgrounds.forEach (bg) =>
        t.li '.background-grid-item', =>
          t.button '.background-grid-trigger', {
            key: bg.value
            className: t.classify {
              'is-photo': bg.isPhoto
              selected: @state.background.value == bg.value
            }
            onClick: => @setBackground bg
            style: createBackgroundStyle bg, { isSmall: true }
            title: bg.value if bg.isColor
            type: 'button'
          }, =>
            if @state.background.value == bg.value
              t.icon 'check'
      t.li '.background-grid-item', =>
        t.button '.background-grid-trigger', {
          onClick: @onBackgroundChooserTriggerClick.bind @
          type: 'button'
        }, =>
              t.icon 'overflow-menu-horizontal'

  renderSubmitButton: =>
    t.button '.primary', {
      className: t.classify { disabled: !@canSubmit() }
      disabled: !@canSubmit()
      ref: (elem) => @submitButtonElem = elem
      style: { width: @submitButtonWidth } if @state.isSubmitting && @submitButtonWidth != 0
      type: 'submit'
    }, =>
      if @state.isSubmitting
        t.span '.logo-loading.subtle.active'
      else
        t.format 'create board'

  renderErrorMessage: =>
    { org } = @state

    # Show error about why they cannot create board
    if org?.allowedVis.length == 0
      t.div '.create-board-permissions-notice', ->
        if org.model.owned()
          t.raw l('board create restriction admin', { urlSettings: "/#{ org.model.get('name') }/account" })
        else
          t.text l('board create restriction not admin')

  onOrgChooserTriggerClick: (e) =>
    if @state.isSubmitting then return
    if @state.isOrgChooserVisible then return

    Util.stop e
    @setState { isOrgChooserVisible: true }

  onVisChooserTriggerClick: (e) =>
    if @state.isSubmitting then return
    if @state.isVisChooserVisible then return

    Util.stop e
    @setState { isVisChooserVisible: true }

  onBackgroundChooserTriggerClick: (e) =>
    if @state.isSubmitting then return

    Util.stop e
    @setState { isBackgroundChooserVisible: true }
    track 'New Board', 'Show Background Chooser'

  onHideDialogTriggerClick: (e) =>
    Util.stop e
    @hideDialog()

  onTitleBlur: (e) =>
    @setState { title: e.target.value.trim() }

  onTitleChange: (e) =>
    @setState { title: e.target.value }

  onSubmit: (e) =>
    if @state.isSubmitting then return

    Util.stop e

    if maybeDisplayMemberLimitsError($(e.target), null, Auth.me())
      return

    @setState { isSubmitting: true }

    # Attributes that will be attached to the board model
    boardAttrs =
      name: @state.title
      idOrganization: @state.org?.model.id

    ownedBoards = _.filter Auth.me().boardList.models, (board) -> board.owned()
    isFirstBoard = (
      # Has no boards
      ownedBoards.length == 0 ||
      # Only has welcome board
      (ownedBoards.length == 1 && ownedBoards[0].isWelcomeBoard())
    )

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend {}, boardAttrs,
      prefs_permissionLevel: @state.vis
      prefs_selfJoin: @state.org? && @state.vis != 'private'
      defaultLists: isFirstBoard

    if @state.background.isPhoto
      requestData['prefs_background_url'] = @state.background.value
      eventLabel = 'photo'
    else if @state.background.isColor
      requestData['prefs_background'] = @state.background.value
      eventLabel = 'color'

    track 'New Board', 'New'

    if @isBackgroundDirty
      track 'New Board', 'Custom Background', eventLabel
    else
      track 'New Board', 'Default Background'

    Auth.me().boardList.create boardAttrs, {
      requestData: requestData
      success: (board) =>
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        idOrganization = board.get('idOrganization')
        LastOrganization.set(idOrganization)

        onBackgroundLoad = =>
          Controller.displayBoard({
            idBoard: board.id
            openListComposer: !isFirstBoard
            openCardComposerInFirstList: isFirstBoard
          })

        backgroundImage = board.get('prefs')?.backgroundImage
        if backgroundImage
          Util.waitForImageLoad backgroundImage
            .then onBackgroundLoad
            .catch onBackgroundLoad
        else
          onBackgroundLoad()
      error: =>
        @setState { isSubmitting: false }
        Alerts.flash('could not create board', 'error', 'create error')
    }

  hideDialog: ->
    Dialog.hide()

  showOrgChooser: =>
    PopOver.show
      displayType: 'mod-no-header'
      elem: @orgTriggerElem
      # Deferred to allow trigger click handler to decide whether it
      # should show or hide the chooser popover based on state
      hidden: =>
        !@isActiveFormElement() && @orgTriggerElem.focus()
        _.defer => @setState { isOrgChooserVisible: false }
      reactElement: React.createElement OrgChooserComponent,
        key: 'org-chooser'
        orgs: @state.orgsWithPermissions
        selectedOrg: @state.org
        onSelect: (org) =>
          @setState { isOrgChooserVisible: false }
          PopOver.hide()
          @setOrg org
          track 'New Board', 'Change Org'

  showVisChooser: =>
    PopOver.show
      displayType: 'mod-no-header'
      elem: @visTriggerElem
      # Deferred to allow trigger click handler to decide whether it
      # should show or hide the chooser popover based on state
      hidden: =>
        !@isActiveFormElement() && @visTriggerElem.focus()
        _.defer => @setState { isVisChooserVisible: false }
      reactElement: React.createElement VisChooserComponent,
        key: 'vis-chooser'
        selectedOrg: @state.org
        selectedVis: @state.vis
        onSelect: (vis) =>
          @setState { isVisChooserVisible: false }
          PopOver.hide()
          @setVis vis
          track 'New Board', 'Change Visibility', vis

  showBackgroundChooser: =>
    { left, top } = @backgroundGridElem.getBoundingClientRect()
    PopOver.show
      clientx: left
      clienty: top
      getViewTitle: -> l ['view title', 'board background']
      hidden: => @setState { isBackgroundChooserVisible: false }
      reactElement: React.createElement BackgroundChooserComponent,
        colors: COLORS
        key: 'background-chooser'
        onColorChooserTriggerClick: => @setState { isColorChooserVisible: true }
        onPhotoChooserTriggerClick: => @setState { isPhotoChooserVisible: true }
        onSelect: @setBackground.bind @
        photos: @state.photos
        selectedBackground: @state.background
      willBePushedUp: => @setState { isBackgroundChooserVisible: true }
      willBePushedDown: => @setState { isBackgroundChooserVisible: false }

  showColorChooser: =>
    PopOver.pushView
      getViewTitle: -> l ['view title', 'change background colors']
      reactElement: React.createElement ColorChooserComponent,
        colors: COLORS
        key: 'color-chooser'
        onSelect: @setBackground.bind @
        selectedBackground: @state.background
      willBePopped: => @setState { isColorChooserVisible: false }

  showPhotoChooser: =>
    PopOver.pushView
      getViewTitle: -> l(['view title', 'change background photos'], {
        unsplashUrl: 'https://unsplash.com?utm_source=trello&utm_medium=referral&utm_campaign=api-credit'
      })
      hasSafeViewTitle: true
      reactElement: React.createElement PhotoChooserComponent,
        key: 'photo-chooser'
        onSelect: @setBackground.bind @
        seedPhotos: @state.photos
        selectedBackground: @state.background
      willBePopped: => @setState { isPhotoChooserVisible: false }

  canSubmit: =>
    (
      # Not already submitting
      !@state.isSubmitting &&
      # Has a board title
      !!@state.title.trim() &&
      # Is finished loading visibility permissions
      !@state.isLoadingVisPermissions &&
      # Either has no org or has a visibility allowed by the org
      (!@state.org? || @state.org.allowedVis.indexOf(@state.vis) > -1)
    )

  isActiveFormElement: ->
    ['INPUT', 'BUTTON'].indexOf(document.activeElement.tagName) > -1

  loadVisPermissions: =>
    @setState { isLoadingVisPermissions: true }
    preloadPermissions()
      .then (orgs) =>
        orgsWithPermissions = orgs.map (org) ->
          allowedVis = ['private', 'org', 'public'].filter((vis) -> org.canSetVisibility vis)
          { allowedVis, model: org }

        @setState { isLoadingVisPermissions: false, orgsWithPermissions }
        @_setOrg _.find orgsWithPermissions, (org) => org.model.id == @state.defaultOrg?.id

  loadPhotos: =>
    @setState { isLoadingPhotos: true }
    preloadPhotos()
      .then (photos) -> photos.map createPhotoFromResponse
      .then (photos) =>
        background = if @isBackgroundDirty then @state.background else photos[0]
        @setState { background, isLoadingPhotos: false, photos }

  # Call this to ensure that field is not marked as dirty
  _setOrg: (org) =>
    vis =  @state.vis
    # 'org' is not a valid visibility for individuals
    if !org? && vis == 'org'
      vis = 'private'
    else if org?
      # default to 'org' visibility if the field is clean and it's allowed
      if !@isVisDirty && org.allowedVis.indexOf('org') > -1
        vis = 'org'
      # otherwise default to the first allowed vis
      else if org.allowedVis.indexOf(vis) == -1
        vis = org.allowedVis[0]

    @setState { org, vis }

  setOrg: (org) =>
    if @state.isSubmitting then return
    @_setOrg org
    @isOrgDirty = true

  # Call this to ensure that field is not marked as dirty
  _setVis: (vis) =>
    @setState { vis }

  setVis: (vis) =>
    if @state.isSubmitting then return
    @_setVis vis
    @isVisDirty = true

  # Call this to ensure that field is not marked as dirty
  _setBackground: (background) =>
    @setState { background }

  setBackground: (background) =>
    if @state.isSubmitting then return
    @_setBackground background
    @isBackgroundDirty = true

  getLastOrganization: ->
    me = Auth.me()
    idLastOrganization = LastOrganization.get()

    me.organizationList.find((org) ->
      org.get('id') == idLastOrganization) ? null



// WEBPACK FOOTER //
// ./app/scripts/views/board-create/create-board-component.coffee